import { render, staticRenderFns } from "./GridCheckbox.vue?vue&type=template&id=36a2c2fd&"
import script from "./GridCheckbox.vue?vue&type=script&lang=js&"
export * from "./GridCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports